import { useNavigate } from 'react-router-dom'
import { BodyText } from 'styling/Typography'
import { IMachineFuelLinkProps } from 'types/fuelConsumption.interface'
import { MachineLinkName } from './MachineFuelLink.styled'

export const MachineFuelLink = ({ name, machineId }: IMachineFuelLinkProps) => {
  const navigate = useNavigate()
  if (!machineId) {
    return <BodyText weight='bold'>{name}</BodyText>
  }
  return (
    <MachineLinkName
      title='Open fuel consumption record'
      onClick={(e) => {
        e.stopPropagation()
        navigate(`/fuel/machines/${machineId}`)
      }}
    >
      {name}
    </MachineLinkName>
  )
}
